import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface FactionDto {
	id: string;
	worldId: string;
	name: string;
	description?: string | null;
	influence?: string | null;
	resources?: string | null;
	opposition?: string | null;
	gmNotes?: string | null;
	iconAssetId?: string | null;
	foundryId?: string | null;
	regionNames?: string | null;
	poiNames?: string | null;
	npcNames?: string | null;
	regionIds?: string[];
	poiIds?: string[];
	npcIds?: string[];
	updatedAt: string;
	createdAt: string;
}

export interface FactionsListResponse {
	factions: FactionDto[];
	total: number;
}

export interface FactionGetResponse {
	faction: FactionDto;
}

export interface UpsertFactionRequest {
	name: string;
	description?: string | null;
	influence?: string | null;
	resources?: string | null;
	opposition?: string | null;
	gmNotes?: string | null;
	iconAssetId?: string | null;
	foundryId?: string | null;
	regionIds?: string[];
	poiIds?: string[];
	npcIds?: string[];
}

@Injectable({ providedIn: 'root' })
export class FactionsService {
	constructor(private readonly http: HttpClient) {}

	list(worldId: string, q?: string): Observable<FactionsListResponse> {
		let params = new HttpParams().set('format', 'list');
		if (q) params = params.set('q', q);
		return this.http.get<FactionsListResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/factions`, { params });
	}

	get(worldId: string, factionId: string): Observable<FactionGetResponse> {
		return this.http.get<FactionGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/factions/${factionId}`);
	}

	create(worldId: string, request: UpsertFactionRequest): Observable<FactionGetResponse> {
		return this.http.post<FactionGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/factions`, {
			Name: request.name,
			Description: request.description ?? null,
			Influence: request.influence ?? null,
			Resources: request.resources ?? null,
			Opposition: request.opposition ?? null,
			GmNotes: request.gmNotes ?? null,
			IconAssetId: request.iconAssetId ?? null,
			FoundryId: request.foundryId ?? null,
			RegionIds: request.regionIds ?? [],
			PoiIds: request.poiIds ?? [],
			NpcIds: request.npcIds ?? [],
		});
	}

	update(worldId: string, factionId: string, request: UpsertFactionRequest): Observable<FactionGetResponse> {
		return this.http.put<FactionGetResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/factions/${factionId}`, {
			Name: request.name,
			Description: request.description ?? null,
			Influence: request.influence ?? null,
			Resources: request.resources ?? null,
			Opposition: request.opposition ?? null,
			GmNotes: request.gmNotes ?? null,
			IconAssetId: request.iconAssetId ?? null,
			FoundryId: request.foundryId ?? null,
			RegionIds: request.regionIds ?? [],
			PoiIds: request.poiIds ?? [],
			NpcIds: request.npcIds ?? [],
		});
	}

	delete(worldId: string, factionId: string): Observable<void> {
		return this.http.delete<void>(`${environment.api.baseUrl}/v1/worlds/${worldId}/factions/${factionId}`);
	}
}
